import { Component } from '@angular/core';
import { usableIcons } from '../icon/icon.component';

interface SocialMediaLink {
  icon: usableIcons;
  href: string;
  title: string;
}

@Component({
  selector: 'vee-navigation-footer',
  templateUrl: './navigation-footer.component.html',
  styleUrls: ['./navigation-footer.component.scss'],
  standalone: false
})
export class NavigationFooterComponent {
  socialMediaLinks: SocialMediaLink[] = [
    {
      icon: 'linkedin',
      href: 'https://www.linkedin.com/company/afq-i-service-ggmbh/?viewAsMember=true',
      title: 'LinkedIn'
    },
    {
      icon: 'instagram',
      href: 'https://www.instagram.com/amuvee.de/',
      title: 'Instagram'
    },
    {
      icon: 'facebook',
      href: 'https://m.facebook.com/amuvee.de/',
      title: 'Facebook'
    },
    {
      icon: 'youtube',
      href: 'https://www.youtube.com/channel/UCfP_iHa4Pk8PWr27uJoIydw/videos',
      title: 'YouTube'
    }
  ];
}
